var $ = require('jquery');

function init() {
  var $navToggle = $('#js-mobile-nav-toggle'),
    $mobileNav = $('.mobile-nav');

  $navToggle.on('click', function(e) {
    e.preventDefault();
    $mobileNav.toggleClass('active');
  });

  $mobileNav.on('click', 'a', function(e) {
    var hasChildren = $(this).parent().hasClass('mobile-nav__li--has-children'),
      $this = $(this),
      $parentUl = $this.closest('.mobile-nav__level'),
      firstLevel = false,
      $target;

    // Check if first level link
    if ($parentUl.hasClass('mobile-nav__level--0')) {
      firstLevel = true;
    } else {
      $target = $(e.target);
    }

    // If first level link or clicked on sub toggle => open child ul
    if (hasChildren && (firstLevel || $target.hasClass('mobile-nav__toggle-sub'))) {
      e.preventDefault();

      $this.next().toggleClass('open');
      $this.toggleClass('selected');
      $this.parent().toggleClass('mobile-nav__li--is-open');
    }
  });

}

module.exports = {
  init
};
